import { create } from 'zustand'

interface ModalState {
   unavailablePhoneNumbers: string[]
   setUnavailablePhoneNumbers: (numbers: string[]) => void
   addUnavailablePhoneNumber: (number: string) => void
   removeUnavailablePhoneNumber: (number: string) => void
   isPhoneNumberUnavailableModalOpen: boolean
   openPhoneNumberUnavailableModal: () => void
   closePhoneNumberUnavailableModal: () => void
}

export const usePhoneNumberUnavailableModalStore = create<ModalState>(
   (set) => ({
      unavailablePhoneNumbers: [],
      setUnavailablePhoneNumbers: (numbers: string[]) =>
         set({ unavailablePhoneNumbers: numbers }),
      addUnavailablePhoneNumber: (number: string) =>
         set((state) => ({
            unavailablePhoneNumbers: [...state.unavailablePhoneNumbers, number],
         })),
      removeUnavailablePhoneNumber: (number: string) =>
         set((state) => ({
            unavailablePhoneNumbers: state.unavailablePhoneNumbers.filter(
               (n) => n !== number
            ),
         })),
      isPhoneNumberUnavailableModalOpen: false,
      openPhoneNumberUnavailableModal: () =>
         set({ isPhoneNumberUnavailableModalOpen: true }),
      closePhoneNumberUnavailableModal: () =>
         set({ isPhoneNumberUnavailableModalOpen: false }),
   })
)
